import React from 'react';
import { ApolloError, useQuery } from '@apollo/client';
import { LoadingLayout } from 'components/molecules/Loaders/LoadingLayout';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { MESSAGES } from '../../helpers/messages';
import { AllFormationsAndTypesQuery } from '../../graphql/generated/graphql';
import { QUERY_FORMATIONS } from '../../graphql/query/formation/queryFormation';
import { RessourcesTypeContainer } from 'components/molecules/Containers/RessourcesTypeContainer';
import { getFormationsTypesFromQuery } from '../../helpers/transformApiResponse/formations';

const Formations = () => {
  const { loading, error, data } = useQuery<AllFormationsAndTypesQuery>(
    QUERY_FORMATIONS
  );
  if (loading) return <LoadingLayout />;
  if (error)
    return (
      <ErrorContainer
        detailErr={
          new ApolloError({
            extraInfo: error,
            errorMessage: 'error query FormationsAllByTypes'
          })
        }
        text={MESSAGES.error.pedagogie}
      />
    );

  const formationsTypes = getFormationsTypesFromQuery(
    data.findFormationTypeWithRelatedFormations
  );

  return (
    <RessourcesTypeContainer ressourcesType={formationsTypes} variant="red" />
  );
};

export default Formations;
